<ng-template #languageDropdownTemplate let-language>
  <span class="dropdown-item-language">{{ language }}</span>
</ng-template>
<pozi-dropdown icon="language" [items]="languages" [showTitle]="false" [(ngModel)]="selectedLanguage"
  (ngModelChange)="onLanguageChange($event)" [template]="languageDropdownTemplate"></pozi-dropdown>